import { RoomState } from './types';
import { ROOM_STATE_CONFIGS } from './constants';

type StateChangeHandler = (newState: RoomState, oldState: RoomState) => void;

export class RoomStateMachine {
  private _state: RoomState = RoomState.Standby;
  private _onChangeHandlers: StateChangeHandler[] = [];
  private _inConversationSession = false;

  get state(): RoomState {
    return this._state;
  }

  get inConversationSession(): boolean {
    return this._inConversationSession;
  }

  get stateConfig() {
    return ROOM_STATE_CONFIGS[this._state];
  }

  onChange(handler: StateChangeHandler): void {
    this._onChangeHandlers.push(handler);
  }

  removeOnChange(handler: StateChangeHandler): void {
    const idx = this._onChangeHandlers.indexOf(handler);
    if (idx !== -1) this._onChangeHandlers.splice(idx, 1);
  }

  transition(newState: RoomState): boolean {
    if (this._state === newState) return false;
    const oldState = this._state;
    this._state = newState;
    if (newState === RoomState.Standby) {
      this._inConversationSession = false;
    }
    for (const handler of this._onChangeHandlers) {
      handler(newState, oldState);
    }
    return true;
  }

  enterConversationSession(): void {
    this._inConversationSession = true;
  }

  exitConversationSession(): void {
    this._inConversationSession = false;
  }

  reset(): void {
    this._state = RoomState.Standby;
    this._inConversationSession = false;
  }

  destroy(): void {
    this._onChangeHandlers = [];
    this.reset();
  }
}
